
import {connect} from 'react-redux';
import axios from 'axios';
import store from "../../../../../redux/store";
import { Platform} from "react-native"

import InformationScreen from '../InformationScreen';
import {
    serviceActionSetState,
    serviceActionSetToken,
    serviceActionSetTypeLogin,
    serviceActionSetUser
} from '../../../splash/action/ActionSplashGetAllData'
import * as  NavigationService from "../../../../../redux/NavigationService";
import {Tools} from "../../../../../tools/Tools";
import base64 from "react-native-base64";
import {AsyngStorageClass} from "../../../../../tools/AsyngStorageClass";
import {typeExport} from "../../../../../redux/store/type";

const mapStateToProps = (state) => ({
    results: state.reducerInformationScreen.results,
    NoInternetDialog: state.reducerInformationScreen.NoInternetDialog,
    isLoading: state.reducerInformationScreen.isLoading,
    DataSplashScreen: state.reducerSplashGetAllData,
});

const mapDispatchToProps = (dispatch, getState) => ({
    callService: (url, params, type, typeConnection, stateData) => dispatch(callWebservice(getState, url, params, type, typeConnection, stateData)),
    callServiceSetUser: (user) => dispatch(serviceActionSetUser(user)),
    callServiceSetToken: (token) => dispatch(serviceActionSetToken(token)),
    callServiceSetState: (data) => dispatch(serviceActionSetState(data)),
    callServiceRefresh: () => dispatch(serviceActionRefresh()),
})

const getDataDisatch = (dispatch, getState, url, params, type, typeConnection, stateData) => {
    dispatch(serviceActionPending());


    const formData = new FormData();
    // formData.append('_operation', params._operation);
    // formData.append('mode', params.mode);

    formData.append('_operation', typeExport._Registration);
    formData.append('mode', 'Register');
    formData.append('lang', params.lang);
    formData.append('mobile', params.mobile);
    formData.append('firstname', params.firstname);
    formData.append('lastname', params.lastname);
    formData.append('password', params.password);
    formData.append('private', params.private);
    formData.append('gender', params.gender);
    formData.append('platform', Platform.OS);

    formData.append('NationalCode', params.NationalCode);
    formData.append('token_code', `Basic ${base64.encode(Tools.persianToEnglish(global._mobile) + ':' + Tools.persianToEnglish(global.CodeMobile))}`);
    //formData.append('token_fb', params.token_fb);
    formData.append('token_fb', store.getState().reducerSplashGetAllData.token_fb);
    Tools.addAllFormData(formData,true,"City")

    const config = {
        headers: {
            "Content-Type": "multipart/form-data; charset=utf-8;",
            timeout: typeExport._TIMEOUT,
            // 'Content-Type': 'application/json',
        }
    };
    /*    axios(
            {
                url: url ,
                method: typeConnection,
                params:params,
                headers: {
                    'Content-Type': 'application/x-www-form-urlencoded'
                },

            }
        )*/

   // axios.post(url, formData, config)
    axios({
        method: 'post',
        url: url,
        data: formData,
        headers: {'Content-Type': 'multipart/form-data'},
        timeout: typeExport._TIMEOUT,

    })
    // axios(
    //     {
    //         url: url,
    //         method: typeConnection,
    //         params: params,
    //         headers: {
    //             'Content-Type': 'application/x-www-form-urlencoded'
    //         },
    //
    //     }
    // )
        .then(async response => {
            switch (type) {

                case typeExport.TypegetDataInformationScreen:
                    if (response.data.success) {
                        await AsyngStorageClass.setAsyng(typeExport._TypeLogin, 1);
                        dispatch(serviceActionSetTypeLogin( 1));
                        await AsyngStorageClass.setAsyng(typeExport._USER, response.data.result);
                        dispatch(serviceActionSuccess(response.data))
                        Tools.SaveTokenUserAsyncProps(response.data.result.token, response.data.result)


                        if (global.ErrorLogin)

                        {
                            global.ErrorLogin = false
                            NavigationService.resetTo('SplashScreen')
                        }
                           // NavigationService.navigatereset('SplashScreen')
                        else {

                            try {
                                let {type, item} = store.getState().reducerSplashGetAllData.STATE
                                NavigationService.navigateParams(type, {item})
                                //    NavigationService.navigateParams('ProfileStack')
                            } catch (e) {
                                //    NavigationService.resetTo("Drawer")

                                NavigationService.PopToPop();
                            }
                        }


                    } else {
                        dispatch(serviceActionRefresh())
                        alert(response.data.error.message)
                    }
                    break;


                default:
            }
        }).catch((e) => {
        dispatch(serviceActionError(e))
    })
}


export const callWebservice = (getState, url, params, type, typeConnection, stateData) => {

    return dispatch => {


        // NetInfo.isConnected.fetch().then(isConnected => {
        //     if (isConnected) {
        //         getDataDisatch(dispatch, getState, url, params, type, typeConnection, stateData);
        //     }
        //     else {
        //         dispatch(serviceActionError("No Internet Connection"));
        //     }
        // });

        // NetInfo.getConnectionInfo().done(
        //     (isConnected) => {
        //         if (isConnected) {
        //             getDataDisatch(dispatch, getState, url, params, type, typeConnection, stateData);
        //         } else {
        //             dispatch(serviceActionError("No Internet Connection"));
        //         }
        //     }
        // )


                if (store.getState().reducerSplashGetAllData.Connection) {
                    getDataDisatch(dispatch, getState, url, params, type, typeConnection, stateData);
                } else {
                    dispatch(serviceActionError("No Internet Connection"));
                }

    }
}


export const serviceActionPending = () => ({
    type: typeExport.InformationScreen_SERVICE_PENDING,
    NoInternetDialog: false,
    isLoading: true,
    results: null

})

export const serviceActionError = (error) => ({
    type: typeExport.InformationScreen_SERVICE_ERROR,
    NoInternetDialog: true,
    isLoading: false,
    error: error
})

export const serviceActionSuccess = (data) => ({
    type: typeExport.InformationScreen_SERVICE_SUCCESS,
    NoInternetDialog: false,
    isLoading: false,
    results: data,


})

export const serviceActionRefresh = () => ({
    type: typeExport.InformationScreen_SERVICE_REFRESH,
    NoInternetDialog: false,
    isLoading: false,
    results: null
})
export default connect(mapStateToProps, mapDispatchToProps)(InformationScreen);
